<template>
    <o-section :level="level" :title="label" body-classes="p-0" not-closable>
        <b-list-group>
            <b-list-group-item class="note_input_item">
                <div class="d-flex w-100 justify-content-between">
                    <b-textarea
                        :rows="rows"
                        @blur="note_blur"
                        @focus="note_focus"
                        @keydown="note_keydown"
                        class="note_input"
                        v-model="newText"
                    ></b-textarea>

                    <b-button @click="save_note">Add</b-button>
                </div>
            </b-list-group-item>
            <b-list-group-item :key="index" v-for="(item, index) in list">
                <div class="d-flex w-100 justify-content-between">
                    <span style="white-space: pre">{{ item.note }}</span>
                    <small v-if="item[whoField]">
                        <user-display
                            :list="users"
                            :value="item[whoField]"
                            default-value="-"
                        ></user-display>
                        at
                        {{
                            item[whenField] | moment("MM/DD/YYYY H:mm a")
                        }}</small
                    >
                </div>
            </b-list-group-item>
        </b-list-group>
    </o-section>
</template>

<script>
/* eslint-disable no-unused-vars */
import _ from "lodash";

import { cleanUpModel } from "../../../schema/schema_vuetify";
import schema from "../../../../app/schema/index";
import { CreateFormStateMixin } from "../../../mixins";
import UserDisplay from "../../display/UserDisplay";
import OWidgetWrapper from "../../forms/OWidgetWrapper";
import { mapGetters } from "vuex";

export default {
    name: "ONotesTable",
    mixins: [CreateFormStateMixin("validator")],
    model: {
        prop: "items",
        event: "changed",
    },
    components: { OWidgetWrapper, UserDisplay },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Object,
            default: () => {},
        },
        modelName: { type: String, default: null },
        label: { type: String, default: null },
        validator: { type: Object, default: () => null },
        serverErrors: { type: Array, default: () => [] },
        usersWorking: { type: Boolean, default: false },
        level: { type: Number, default: 0 },

        whoField: {
            type: String,
            default: "who",
        } /* What Field in the Model has the User ID */,
        whenField: {
            type: String,
            default: "when",
        } /* What Field in the Model has the Date when it was created/uploaded */,
    },
    data: function () {
        return {
            defaultNewValue: { _is_new: true },
            schema: cleanUpModel(schema[this.modelName], {}),
            newText: "",
            rows: 1,
        };
    },
    methods: {
        note_keydown(event) {
            if (event.ctrlKey && event.keyCode == 13) {
                this.save_note();
            }
        },
        note_focus() {
            this.rows = 6;
        },
        note_blur() {
            if (this.newText == "") {
                this.rows = 1;
            }
        },
        save_note() {
            if (this.newText) {
                var note = { note: this.newText };

                note[this.whenField] = new Date(); // put now in there!
                note[this.whoField] = this.currentUser.id;

                this.newText = ""; // clear
                this.rows = 1; // shrink it now..

                console.log("HERE!");

                var newList = _.cloneDeep(this.list);
                newList.splice(0, 0, note);

                this.changed(newList);
            }
        },
        changed(list) {
            if (this.validator) {
                this.validator.$touch();
            }
            if (this.formState) this.formState.dirty = true;

            this.$emit("changed", list);
        },
        canSee(schema, field_name) {
            /* Here we can check if they have permission for the field */
            return true;
        },
    },
    computed: {
        ...mapGetters("AuthModule", ["currentUser"]),
        list() {
            // Make sure we have a list!

            return this.items || [];
        },
    },
    created() {},
};
</script>

<style>
.note_input {
}

.note_input_item {
    padding: 0px !important;
}
</style>
